import {makeAutoObservable, runInAction} from "mobx";
import {
    login as loginReq,
    getUserInfo,
    userSign,
    encrypt,
    userLink,
    userLogout
} from "../utils/serverRequest";
import { MSG_TYPE, msgbox } from "../utils/Msgbox";
import { IMG_PREFIX_1 } from "../utils/serverRequest";
import Images from "../utils/Images";
import { LOGIN_SERVER, WEB_VERSION_URL } from "../utils/serverRequest";

export class CommonStore {
    count = 0;
    coins = 0

    private token:string = "";
    private userInfo:any = null;
    private loginPage: string = encodeURI(`${LOGIN_SERVER}client=0&scheme=yunmo&redirect=${WEB_VERSION_URL}`);
    private loginPageWeb: string = encodeURI(`${LOGIN_SERVER}client=1&scheme=yunmo&redirect=${WEB_VERSION_URL}`);
    private ID = "com.hanchao.yunmo.sd.official";
    private newVersionInfo:any = null;
    private _loading: boolean = false;
    private _loadingTransparent: boolean = false;

    get loading(): boolean{
        return this._loading;
    }

    get loadingTransparent(): boolean{
        return this._loadingTransparent;
    }

    get isVip(): boolean{
        return !!this.userInfo ? this.userInfo.data.type === "3" : false;
    }

    get expireDate(): string{
        return !!this.userInfo ? this.userInfo.data.expireDate : "";
    }

    constructor() {
        makeAutoObservable(this)
    }

    toLoginPage = (): void => {
        window.open(this.loginPageWeb, "_self");
    };

    getNewVersionStr = (): string => {
        return this.newVersionInfo.version || "0";
    };

    getNewVersionInfo = (): string => {
        return this.newVersionInfo.content || "";
    };

    getToken = ():string => {
        return this.token;
    }

    get userId(): number{
        return !!this.userInfo ? this.userInfo.data.userId : -1;
    }

    getNickname = ():string => {
        return !!this.userInfo ? this.userInfo.data.nickname : "请登录";
    }

    getUsername = ():string => {
        return !!this.userInfo ? this.userInfo.data.userName : "无";
    };

    setNickname = (a:string) => {
        this.userInfo.data.nickname = a;
    }

    getSignature = ():string => {
        return !!this.userInfo ? this.userInfo.data.signature || "测试签名" : "无";
    }

    setSignature = (a:string) => {
        this.userInfo.data.signature = a;
    }

    increaseCount() {
        this.count += 1
    }

    decreaseCount() {
        this.count -= 1
    }

    updateLoading(value: boolean, transparent:boolean = false) {
        runInAction(() => {
            this._loading = value;
            this._loadingTransparent = transparent;
        });
    }

    getIsLogin = ():boolean => {
        return !!this.userInfo;
    }

    getAvatar = ():string => {
        if(!this.userInfo){
            return Images.avatar_0;
        }

        const avatar = this.userInfo.data.avatar;
        if(avatar.length <= 0){
            return Images.avatar_0;
        }

        return `${IMG_PREFIX_1}${avatar.substring(1)}`;
    }

    setAvatar = (a:string) => {
        this.userInfo.data.avatar = a;
    }

    refreshUserInfo = async()=>{
        const info = await getUserInfo(this.token);
        if(info.code != 200){
            msgbox(info.msg, MSG_TYPE.ERROR)
            return;
        }

        runInAction(() => {
            this.userInfo = info;
        });
    }

    getCoins = () => {
        return !!this.userInfo ? this.userInfo.data.coins : 0;
    }

    getGiftCoins = () => {
        return this.userInfo && this.userInfo.data.giftCoins ?  this.userInfo.data.giftCoins: 0;
    }
    
    getTotalCoins = (): number => {
        return this.getCoins() + this.getGiftCoins();
    };

    getRefCode = () =>{
        return this.userInfo && this.userInfo.data.refCode ? this.userInfo.data.refCode : "";
    }

    isAdmin = () => {
        if(!this.userInfo){
            return false;
        }

        const roles = this.userInfo.data.roles;
        if(!roles){
            return false;
        }

        return roles.some((o:any) => o === "yunmo" || o === "admin" || o === "yunmo_post");
    }

    autoLogin = (token:string) :Promise<void> => {
        return getUserInfo(token).then((res) => {
            runInAction(() => {
                this.userInfo = res;
                this.token = token;
            });
        }).catch((_) => {return Promise.resolve()});
    }


    logout = (): void => {
        userLogout().then(() => {});
        localStorage.removeItem("token");
        this.userInfo = null;
        this.token = "";
    }

    updateUserInfo = async (token:string): Promise<void> => {
        return getUserInfo(token).then((res) => {
            runInAction(() => {
                this.userInfo = res;
                this.token = token;
            });
        }).catch((_) => {return Promise.resolve()});
    };

    runWithLoadingAnim = (a: Promise<any>): void => {
        this.updateLoading(true);
        a.catch(reason => msgbox(reason.message, MSG_TYPE.ERROR)).finally(() => this.updateLoading(false));
    };
}